const SendIcon = ({ color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<defs />
			<path
				fill={color}
				d="M22.639,3.759 L16.3,21.507 C15.669,23.274 13.122,23.121 12.706,21.292 L10.872,13.129 L2.71,11.295 C0.88,10.88 0.728,8.332 2.495,7.701 L20.242,1.363 C21.732,0.831 23.171,2.269 22.639,3.759 Z M20.747,2.776 L2.999,9.114 C2.646,9.24 2.676,9.749 3.041,9.833 L11.262,11.679 L14.47,8.471 C14.763,8.178 15.237,8.178 15.53,8.471 C15.823,8.764 15.823,9.239 15.53,9.532 L12.322,12.74 L14.169,20.96 C14.252,21.325 14.761,21.356 14.887,21.003 L21.226,3.255 C21.332,2.957 21.045,2.669 20.747,2.776 Z"
			/>
		</svg>
	);
};

export default SendIcon;
